import * as React from 'react';
import { BaseWidgetProps } from '../../widget-container';
import { isChatOpen } from '../../../common/is-chat-open';
import { ChatClosed } from '../../new-widget-container/chat-closed';
import { ContactMode } from '@wix/answers-api';
import { ChatRoom } from '../../new-widget-container/chat-room';
import { ContactPage, ContactPageMode } from '../../new-widget-container/contact-page/index';
import { WidgetMessage, WidgetMessageType, ChatRoomPreviewMode } from '../../../common/message-types';

export type ChatRoomLoaderProps = {
	baseConfig: BaseWidgetProps;
};

export enum ChatLoaderModule {
	CHAT_CLOSED,
	CONTACT_PAGE,
	CHAT_ROOM
}

export type ChatRoomLoaderState = {
	visibleModule: ChatLoaderModule;
	previewMode?: ChatRoomPreviewMode;
};

export class ChatRoomLoader extends React.PureComponent<ChatRoomLoaderProps, ChatRoomLoaderState> {
	state: ChatRoomLoaderState = {
		visibleModule: ChatLoaderModule.CHAT_ROOM
	};

	componentDidMount () {
		setTimeout(() => {
			this.forceUpdate();
		});
		if (!this.props.baseConfig.isPreview) {
			const {baseConfig} = this.props;
			const {chatModuleSettings, tenant} = baseConfig.widgetConfig;
			const {outsideBusinessHoursSettings} = chatModuleSettings;
			const chatOpen = isChatOpen(chatModuleSettings.businessHours, tenant.timeZone);
			const showChatClosed = !chatOpen && outsideBusinessHoursSettings.contactMode === ContactMode.BLOCK_CHAT;
			const showContactPage = !chatOpen && outsideBusinessHoursSettings.contactMode === ContactMode.CONTACT_FORM;
			this.setState({
				visibleModule: showChatClosed ? ChatLoaderModule.CHAT_CLOSED :
				showContactPage ? ChatLoaderModule.CONTACT_PAGE : ChatLoaderModule.CHAT_ROOM
			});
		}
		if (window) {
			window.addEventListener('message', this.handleSettingsPostMessage);
		}
	}

	componentWillUnmount () {
		if (window) {
			window.removeEventListener('message', this.handleSettingsPostMessage);
		}
	}

	handleSettingsPostMessage = (event: MessageEvent) => {
		const widgetMessage: WidgetMessage = event.data.__ansWidget;
		if (widgetMessage) {
			switch (widgetMessage.type) {
				case WidgetMessageType.GO_TO_CHAT_CLOSED_VIEW:
					this.setState({visibleModule: ChatLoaderModule.CHAT_CLOSED, previewMode: undefined});
					break;
				case WidgetMessageType.GO_TO_CHAT_CONTACT_PAGE:
					this.setState({visibleModule: ChatLoaderModule.CONTACT_PAGE, previewMode: undefined});
					break;
				case WidgetMessageType.GO_TO_CHAT_ROOM:
					this.setState({visibleModule: ChatLoaderModule.CHAT_ROOM, previewMode: widgetMessage.data.previewMode});
					break;
				default:
					break;
			}
		}
	}

	render () {
		const {baseConfig} = this.props;

		switch (this.state.visibleModule) {
			case ChatLoaderModule.CHAT_CLOSED:
				return <ChatClosed baseWidgetProps={baseConfig} />;
			case ChatLoaderModule.CONTACT_PAGE:
				return (
					<ContactPage
						baseConfig={baseConfig}
						t={baseConfig.translate}
						mode={ContactPageMode.CHAT_CLOSED_CONTACT_PAGE}
					/>
				);
			case ChatLoaderModule.CHAT_ROOM:
				return (
					<ChatRoom
						baseWidgetProps={baseConfig}
						previewMode={this.state.previewMode}
					/>
				);
		}
	}
}
